import { Component, OnInit, Inject } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  AbstractControl,
  FormControl
} from "@angular/forms";
import { Constants } from "@app/shared/constants/app.constants";
import { Router, Params, ActivatedRoute } from "@angular/router";
import swal from "sweetalert2";
import { UserVerificationService } from "@app/shared/services/user-verification.service";
import { AppStateService } from "@app/shared/services/app-state.service";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"]
})
export class ChangePasswordComponent implements OnInit {
  changePassword: FormGroup;
  accessToken = "";
  userDetails;
  constructor(
    public formBulder: FormBuilder,
    public UserVerificationService: UserVerificationService,
    public router: Router,
    private appState: AppStateService,
    @Inject(DOCUMENT) private document: Document,
    public routerSnapShot: ActivatedRoute
  ) {
    // window.scroll(0, 0);
    const snapshot = routerSnapShot.snapshot;

    this.document.body.classList.add("inner-page");
    this.changePassword = this.formBulder.group(
      {
        oldPassword: formBulder.control("", [
          Validators.required,
          Validators.pattern(Constants.passwordRegex)
        ]),
        newPassword: formBulder.control("", [
          Validators.required,
          Validators.pattern(Constants.passwordRegex)
        ]),
        confirmPassword: formBulder.control("", [
          Validators.required
          // this.passwordMatch.bind(this)
        ])
      },
      {
        validator: [Validators.required, this.passwordMatch.bind(this)]
      }
    );
  }

  ngOnInit() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      // this.appState.setState(true);
      this.userDetails = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.accessToken = this.userDetails.accessToken;
    }
  }

  submit() {
    if (this.changePassword.valid === false) {
      this.validateAllFormFields(this.changePassword);
    } else if (this.changePassword.valid === true) {


      this.UserVerificationService
        .changePassword(this.accessToken, this.changePassword.value)
        .subscribe(
          (data: any) => {
            this.accessToken = JSON.parse(
              window.sessionStorage.getItem("userDetails")
            ).accessToken;

            this.appState.logout(this.accessToken);

            this.router.navigate(["/signin"]);
            window.sessionStorage.clear();
            window.localStorage.setItem("logoutStatus", "true");
            this.appState.setState(false);

            swal(
              "Your password has been changed successfully"
            );
             // fix reditect login
            this.router.navigate(["/signin"]);

          },
          error => {


            swal("Info", error.error.error.message, "info");
          }
        );
    }
  }

  passwordMatch(control: AbstractControl) {
    if (
      control.get("newPassword").value !== control.get("confirmPassword").value
    ) {
      return new Promise(resolve => resolve({ passNotMatch: true }));
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/change-password/change-password.component.ts